module.exports = __webpack_public_path__ + "static/media/tank.f0c47d90.jpg";